import React, { createContext } from 'react';

export interface ICategorizationContext {
  categorizedExpensesCounter: number;
  setCategorizedExpensesCounter: React.Dispatch<React.SetStateAction<number>>;
  categorizedIncomeCounter: number;
  setCategorizedIncomeCounter: React.Dispatch<React.SetStateAction<number>>;
}

export const CategorizationContext = createContext<ICategorizationContext>({
  categorizedExpensesCounter: 0,
  setCategorizedExpensesCounter: () => {},
  categorizedIncomeCounter: 0,
  setCategorizedIncomeCounter: () => {},
});
